"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _scrollparent = _interopRequireDefault(require("scrollparent"));

var scrollIntoView = function scrollIntoView(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    offset: 0,
    behavior: 'auto'
  };
  var offset = options.offset,
      behavior = options.behavior;

  if (!element) {
    return;
  }

  var container = (0, _scrollparent["default"])(element);

  if (container === document.documentElement) {
    var y = element.getBoundingClientRect().top + window.pageYOffset + parseFloat(offset);
    window.scrollTo({
      top: y,
      behavior: behavior
    });
  } else {
    var _y = element.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop + parseFloat(offset);

    container.scrollTo({
      top: _y,
      behavior: behavior
    });
  }
};

var _default = scrollIntoView;
exports["default"] = _default;